// extracted by mini-css-extract-plugin
export var languageContainer = "LanguageSwitch-module--languageContainer--1yv4y";
export var separator = "LanguageSwitch-module--separator--1hPJY";
export var language = "LanguageSwitch-module--language--23OBE";